<div class="container mt-4">
  <h2 class="mb-4">HISTORIQUE DES HEURES DE CONDUITE</h2>

  <div class="bg-light p-3 mb-4 rounded">
    <div class="btn-group mb-3" role="group">
      <button type="button" class="btn" [ngClass]="mode === 'slot' ? 'btn-primary' : 'btn-outline-primary'"
              (click)="onChangeMode('slot')">
        <i class="fa fa-clock-o"></i> Par créneau
      </button>
      <button type="button" class="btn" [ngClass]="mode === 'period' ? 'btn-primary' : 'btn-outline-primary'"
              (click)="onChangeMode('period')">
        <i class="fa fa-calendar"></i> Par période
      </button>
    </div>

    <form *ngIf="mode === 'slot'" class="form-row align-items-end" (ngSubmit)="onSearchSlot()">
      <div class="col-md-3 mb-2">
        <label for="slotDate">Date</label>
        <input id="slotDate" type="date" class="form-control" [(ngModel)]="slotDate" name="slotDate" required>
      </div>
      <div class="col-md-2 mb-2">
        <label for="slotHour">Heure</label>
        <input id="slotHour" type="time" step="3600" class="form-control" [(ngModel)]="slotHour" name="slotHour" required>
      </div>
      <div class="col-md-4 mb-2">
        <label for="slotMonitor">Moniteur</label>
        <select id="slotMonitor" class="form-control" [(ngModel)]="slotMonitorId" name="slotMonitorId">
          <option [ngValue]="null">Tous les moniteurs</option>
          <option *ngFor="let m of monitors" [ngValue]="m.id">{{ m.firstname }} {{ m.lastname }}</option>
        </select>
      </div>
      <div class="col-md-3 mb-2">
        <button type="submit" class="btn btn-primary btn-block" [disabled]="loading">
          <i class="fa fa-search"></i> Rechercher
        </button>
      </div>
    </form>

    <form *ngIf="mode === 'period'" class="form-row align-items-end" (ngSubmit)="onSearchPeriod()">
      <div class="col-md-3 mb-2">
        <label for="periodStart">Du</label>
        <input id="periodStart" type="date" class="form-control" [(ngModel)]="periodStart" name="periodStart" required>
      </div>
      <div class="col-md-3 mb-2">
        <label for="periodEnd">Au</label>
        <input id="periodEnd" type="date" class="form-control" [(ngModel)]="periodEnd" name="periodEnd" required>
      </div>
      <div class="col-md-3 offset-md-3 mb-2">
        <button type="submit" class="btn btn-primary btn-block" [disabled]="loading">
          <i class="fa fa-search"></i> Rechercher
        </button>
      </div>
    </form>
  </div>

  <div class="alert alert-danger" *ngIf="messageError">{{ messageError }}</div>
  <div class="text-muted" *ngIf="loading"><i class="fa fa-spinner fa-spin"></i> Chargement...</div>

  <!-- ===== Choix de l'affichage (recherche par créneau uniquement) ===== -->
  <div class="view-switch mb-3" *ngIf="mode === 'slot' && searched">
    <span class="view-switch__label">Affichage :</span>
    <div class="btn-group btn-group-sm" role="group">
      <button type="button" class="btn" [ngClass]="viewMode === 'event' ? 'btn-secondary' : 'btn-outline-secondary'"
              (click)="viewMode = 'event'">
        <i class="fa fa-th-list"></i> Par heure
      </button>
      <button type="button" class="btn" [ngClass]="viewMode === 'monitor' ? 'btn-secondary' : 'btn-outline-secondary'"
              (click)="viewMode = 'monitor'">
        <i class="fa fa-id-badge"></i> Chronologie par moniteur
      </button>
    </div>
  </div>

  <!-- ===== Résultats par créneau : par heure ===== -->
  <ng-container *ngIf="mode === 'slot' && searched && viewMode === 'event'">
    <div class="slot-summary mb-3">
      <div class="slot-summary__title">
        <i class="fa fa-clock-o"></i> Créneau recherché : <strong>{{ searchedSlot }}</strong>
        <span class="text-muted">· {{ searchedMonitor }}</span>
      </div>
      <div class="slot-summary__counts" *ngIf="groups.length > 0">
        <span class="status-pill status-pill--here">
          <i class="fa" [ngClass]="statuses.here.icon"></i> {{ countByStatus('here') }} sur ce créneau
        </span>
        <span class="status-pill status-pill--moved">
          <i class="fa" [ngClass]="statuses.moved.icon"></i> {{ countByStatus('moved') }} déplacée(s) ailleurs
        </span>
        <span class="status-pill status-pill--deleted">
          <i class="fa" [ngClass]="statuses.deleted.icon"></i> {{ countByStatus('deleted') }} supprimée(s)
        </span>
      </div>
    </div>

    <div class="alert alert-info" *ngIf="groups.length === 0">Aucun historique pour ce créneau.</div>

    <div class="history-card mb-4" *ngFor="let group of groups" [ngClass]="'history-card--' + group.status">
      <div class="history-card__header">
        <div>
          <div class="history-card__title">
            Heure n°{{ group.eventId }}
            <span class="status-pill" [ngClass]="'status-pill--' + group.status">
              <i class="fa" [ngClass]="statuses[group.status].icon"></i> {{ statuses[group.status].label }}
            </span>
          </div>
          <div class="history-card__current">
            <span class="history-card__current-label">
              {{ group.status === 'deleted' ? 'Dernier état connu' : 'Position actuelle' }} :
            </span>
            <span [class.text-deleted]="group.status === 'deleted'">
              <i class="fa fa-clock-o"></i> <strong>{{ group.slot }}</strong>
              <span class="sep">·</span><i class="fa fa-id-badge"></i> {{ group.monitor }}
              <span class="sep">·</span><i class="fa fa-user"></i> {{ group.student }}
            </span>
          </div>
          <div class="history-card__hint" *ngIf="group.status === 'moved'">
            Cette heure est passée par le créneau recherché mais se trouve maintenant le <strong>{{ group.slot }}</strong>.
          </div>
        </div>
      </div>

      <ul class="timeline">
        <ng-container *ngFor="let row of group.rows">
          <ng-container *ngTemplateOutlet="timelineItem; context: {row: row, showSlot: false}"></ng-container>
        </ng-container>
      </ul>
    </div>
  </ng-container>

  <!-- ===== Résultats par créneau : chronologie par moniteur ===== -->
  <ng-container *ngIf="mode === 'slot' && searched && viewMode === 'monitor'">
    <div class="slot-summary mb-3">
      <div class="slot-summary__title">
        <i class="fa fa-clock-o"></i> Créneau recherché : <strong>{{ searchedSlot }}</strong>
        <span class="text-muted">· {{ searchedMonitor }} · {{ monitorTimelines.length }} moniteur(s)</span>
        <span class="status-pill status-pill--count ml-1">
          <i class="fa fa-car"></i> {{ slotHourCount() }} heure(s) sur le créneau
        </span>
      </div>
      <div class="btn-group btn-group-sm" *ngIf="monitorTimelines.length > 1">
        <button type="button" class="btn btn-outline-secondary" (click)="setAllCollapsed(false)">
          <i class="fa fa-expand"></i> Tout développer
        </button>
        <button type="button" class="btn btn-outline-secondary" (click)="setAllCollapsed(true)">
          <i class="fa fa-compress"></i> Tout réduire
        </button>
      </div>
    </div>

    <div class="role-legend mb-3" *ngIf="monitorTimelines.length > 0">
      <span class="slot-move slot-move--created"><i class="fa fa-plus"></i> créée sur le créneau</span>
      <span class="slot-move slot-move--arrived"><i class="fa fa-sign-in"></i> arrive d'un autre créneau / moniteur</span>
      <span class="slot-move slot-move--stay"><i class="fa fa-dot-circle-o"></i> reste sur le créneau</span>
      <span class="slot-move slot-move--left"><i class="fa fa-sign-out"></i> quitte le créneau</span>
      <span class="slot-move slot-move--deleted"><i class="fa fa-trash"></i> supprimée</span>
    </div>

    <div class="alert alert-info" *ngIf="monitorTimelines.length === 0">Aucune opération pour ce créneau.</div>

    <div class="monitor-card mb-4" *ngFor="let t of monitorTimelines" [ngClass]="'monitor-card--' + cardStatus(t)">
      <div class="monitor-card__header" (click)="toggleMonitor(t)" role="button">
        <div class="monitor-card__identity">
          <i class="fa monitor-card__chevron" [ngClass]="isCollapsed(t) ? 'fa-chevron-right' : 'fa-chevron-down'"></i>
          <span class="monitor-card__avatar"><i class="fa fa-id-badge"></i></span>
          <div>
            <div class="monitor-card__name">{{ t.monitorName }}</div>
            <div class="monitor-card__counts">
              {{ t.eventCount }} heure(s) distincte(s) · {{ t.operationCount }} opération(s)
            </div>
          </div>
        </div>
        <div class="monitor-card__current">
          <span class="monitor-card__current-label">Dernière affectation</span>
          <ng-container *ngIf="currentOccupants(t).length > 0; else freeSlot">
            <span class="status-pill status-pill--here" *ngFor="let o of currentOccupants(t)">
              <i class="fa fa-user"></i> {{ o.studentName || 'Sans élève' }} · n°{{ o.eventId }}
            </span>
          </ng-container>
          <ng-template #freeSlot>
            <ng-container *ngIf="cardStatus(t) === 'deleted'">
              <span class="status-pill status-pill--deleted">
                <i class="fa fa-user"></i> {{ entryStudent(lastEntry(t)) }} · n°{{ lastEntry(t).history.eventId }} · supprimée
              </span>
              <span class="monitor-card__current-meta">
                le {{ formatModifiedAt(lastEntry(t).history.modifiedAt) }} par {{ lastEntry(t).history.modifiedBy }}
              </span>
            </ng-container>
            <ng-container *ngIf="cardStatus(t) === 'left'">
              <span class="status-pill status-pill--moved">
                <i class="fa fa-user"></i> {{ entryStudent(lastEntry(t)) }} · n°{{ lastEntry(t).history.eventId }} · déplacée
              </span>
              <span class="monitor-card__current-meta">{{ roleContext(lastEntry(t)) }}</span>
            </ng-container>
            <span class="status-pill status-pill--free" *ngIf="cardStatus(t) === 'unknown'">
              <i class="fa fa-circle-o"></i> Créneau libre
            </span>
          </ng-template>
        </div>
      </div>

      <div class="monitor-card__warning" *ngIf="!t.consistent">
        <i class="fa fa-exclamation-triangle"></i>
        L'état réel du planning diffère de l'historique (heure(s) n°{{ mismatchedEvents(t).join(', n°') }}) :
        une heure n'a probablement pas d'historique. La dernière affectation affichée est l'état réel.
      </div>
      <div class="monitor-card__hint" *ngIf="t.actualOccupants === null">
        <i class="fa fa-info-circle"></i> État réel du planning non vérifié : dernière affectation reconstruite à partir de l'historique.
      </div>

      <ul class="timeline" *ngIf="!isCollapsed(t)">
        <li class="text-muted pb-3" *ngIf="t.entries.length === 0">Aucune opération enregistrée pour ce moniteur.</li>
        <li class="timeline__item" *ngFor="let e of t.entries"
            [ngClass]="'timeline__item--' + e.history.action.toLowerCase()">
          <span class="timeline__dot"><i class="fa" [ngClass]="actionIcon(e.history)"></i></span>
          <div class="timeline__header">
            <strong class="timeline__action">{{ entryActionLabel(e.history) }}</strong>
            <span class="slot-move" [ngClass]="'slot-move--' + roleClass(e)">
              <i class="fa" [ngClass]="roleIcons[roleClass(e)]"></i>
              {{ roleLabel(e) }}
            </span>
            <span class="timeline__meta">
              le {{ formatModifiedAt(e.history.modifiedAt) }} par <strong>{{ e.history.modifiedBy }}</strong>
            </span>
          </div>
          <div class="timeline__slot">
            Heure n°{{ e.history.eventId }} · <i class="fa fa-user"></i> {{ entryStudent(e) }}
            <span class="timeline__context" *ngIf="roleContext(e)">· {{ roleContext(e) }}</span>
          </div>
          <ul class="changes">
            <li *ngFor="let c of changesOf(e.history)" class="changes__item">
              <span class="changes__label"><i class="fa" [ngClass]="c.icon"></i> {{ c.label }}</span>
              <span class="changes__old" [ngClass]="e.history.action === 'DELETE' ? 'changes__old--deleted' : 'changes__old--replaced'"
                    *ngIf="c.from !== undefined">{{ c.from }}</span>
              <i class="fa fa-long-arrow-right changes__arrow" *ngIf="c.from !== undefined && c.to !== undefined"></i>
              <span class="changes__new" *ngIf="c.to !== undefined">{{ c.to }}</span>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </ng-container>

  <!-- ===== Résultats par période ===== -->
  <ng-container *ngIf="mode === 'period' && searched">
    <div class="alert alert-info" *ngIf="rows.length === 0">Aucune action sur cette période.</div>
    <div class="history-card" *ngIf="rows.length > 0">
      <div class="history-card__header">
        <div class="history-card__title">{{ rows.length }} action(s), de la plus récente à la plus ancienne</div>
      </div>
      <ul class="timeline">
        <ng-container *ngFor="let row of rows">
          <ng-container *ngTemplateOutlet="timelineItem; context: {row: row, showSlot: true}"></ng-container>
        </ng-container>
      </ul>
    </div>
  </ng-container>

  <!-- ===== Élément de frise ===== -->
  <ng-template #timelineItem let-row="row" let-showSlot="showSlot">
    <li class="timeline__item" [ngClass]="'timeline__item--' + row.history.action.toLowerCase()">
      <span class="timeline__dot"><i class="fa" [ngClass]="actionIcon(row.history)"></i></span>
      <div class="timeline__header">
        <strong class="timeline__action">{{ actionLabel(row.history) }}</strong>
        <span class="slot-move slot-move--in" *ngIf="row.slotMove === 'in'">
          <i class="fa fa-sign-in"></i> arrive sur le créneau
        </span>
        <span class="slot-move slot-move--out" *ngIf="row.slotMove === 'out'">
          <i class="fa fa-sign-out"></i> quitte le créneau
        </span>
        <span class="timeline__meta">
          le {{ formatModifiedAt(row.history.modifiedAt) }} par <strong>{{ row.history.modifiedBy }}</strong>
        </span>
      </div>
      <div class="timeline__slot" *ngIf="showSlot">
        Heure n°{{ row.history.eventId }} du <strong>{{ slotOf(row.history) }}</strong>
      </div>
      <ul class="changes">
        <li *ngFor="let c of row.changes" class="changes__item">
          <span class="changes__label"><i class="fa" [ngClass]="c.icon"></i> {{ c.label }}</span>
          <span class="changes__old" [ngClass]="row.history.action === 'DELETE' ? 'changes__old--deleted' : 'changes__old--replaced'"
                *ngIf="c.from !== undefined">{{ c.from }}</span>
          <i class="fa fa-long-arrow-right changes__arrow" *ngIf="c.from !== undefined && c.to !== undefined"></i>
          <span class="changes__new" *ngIf="c.to !== undefined">{{ c.to }}</span>
        </li>
        <li *ngIf="row.changes.length === 0" class="text-muted">Aucun changement visible</li>
      </ul>
    </li>
  </ng-template>
</div>
